import * as React from 'react';
import { Checkbox as $Checkbox } from 'antd';
import { FieldProps } from 'formik';
import { Field } from 'formik-antd';
import { FormikFieldProps } from 'formik-antd/lib/FieldProps';
import { CheckboxProps as $CheckboxProps } from 'antd/lib/checkbox/Checkbox';

export type CheckboxProps = FormikFieldProps & $CheckboxProps;

export default function Checkbox({
  name,
  validate,
  fast,
  onChange,
  ...restProps
}: CheckboxProps) {
  return (
    <Field name={name} validate={validate} fast={fast}>
      {({
        field: { value },
        form: { setFieldValue, setFieldTouched },
      }: FieldProps) => (
        // eslint-disable-next-line react/jsx-pascal-case
        <$Checkbox
          name={name}
          checked={value}
          onChange={(event) => {
            setFieldValue(name, event.target.checked);
            onChange && onChange(event);

            setTimeout(() => {
              setFieldTouched(name, true, false);
            }, 0);
          }}
          {...restProps}
        />
      )}
    </Field>
  );
}
